import { SignUpForms } from "./SignUpForms";
import { useSignUpContext } from "./context";
import { ProviderSelectForm } from "./forms/ProviderSelectForm";
import { UserSelectForm } from "./forms/UserSelectForm";

export const SignUpSteps = () => {
  const { step } = useSignUpContext();

  switch (step) {
    case "provider-select":
      return <ProviderSelectForm />;
    case "signup":
      return <SignUpForms />;
    default:
      return <UserSelectForm />;
  }
};
